import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { normalizeStructuredContent, scInjectDynamicText } from 'api';
import { useGlobalContext } from 'globalContext';
import Error404 from 'components/Error404';
import { StructuredContent } from 'msp-components';
import styles from './PageTitle.module.scss';

const PageTitle = ({ routeProps, structuredContent = [], ...rest }) => {
  const { project } = useGlobalContext();

  const blocks = useMemo(() => {
    return scInjectDynamicText(normalizeStructuredContent(structuredContent), rest, null, project);
  }, [structuredContent, rest, project]);

  if (!routeProps.match.isExact) return <Error404 />;

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <StructuredContent blocks={blocks} />
      </div>
    </div>
  );
};

PageTitle.propTypes = {
  routeProps: PropTypes.object,
  structuredContent: PropTypes.arrayOf(PropTypes.object),
};

export default PageTitle;
